function isProtectedApp() {
  const element = document.querySelector('meta[name="backstage-app-mode"]');
  const appMode = element?.getAttribute("content") ?? "public";
  return appMode === "protected";
}

export { isProtectedApp };
//# sourceMappingURL=isProtectedApp.esm.js.map
